import { useDialogStore } from "@/shared/stores";
import { Button } from "@spz/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@spz/ui/components/dialog";
import { useTranslation } from "react-i18next";

export const GlobalDialog = () => {
  const { header, content, isOpen, footer, closeDialog } = useDialogStore();
  const { t } = useTranslation();

  const dialogTitle = header?.title ?? t("dialog_untitled");

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent title={dialogTitle} description={header?.description}>
        {header && (
          <DialogHeader
            title={header.title}
            titleIcon={header.icon}
            description={header.description}
            data-testid="dialog-title"
          />
        )}

        {content}

        {isOpen && (
          <DialogFooter hint={footer?.hint}>
            <div className="flex justify-end gap-2 w-full">
              <Button
                variant="secondary"
                onClick={closeDialog}
                aria-label={t("dialog_close_button", {
                  defaultValue: "Close ${dialogTitle} dialog",
                })}
                data-testid="dialog-close-button"
              >
                {t("close")}
              </Button>
              {footer?.actions}
            </div>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
